import React from 'react';
import { FWurfData, milestones } from '../data/FWurfData';
import { SollData } from '../data/SollData';
import ChartWithStats from '../components/ChartWithStats';

export function ChartFWurfOnly() {
    const puppyEntries = Object.values(FWurfData);
    const arrayLength = 64;
    const startDate = new Date(2024, 11, 28);

    const labels = Array.from({ length: arrayLength }, (_, i) => {
        const currentDate = new Date(startDate);
        currentDate.setDate(startDate.getDate() + i);
        return currentDate.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' });
    });

    const chartDatasets = puppyEntries.map(puppy => ({
        label: puppy.label,
        data: puppy.data,
        borderColor: puppy.borderColor,
        backgroundColor: puppy.backgroundColor,
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 5,
        sex: puppy.sex,
        borderWidth: 3
    }));

    chartDatasets.push(
        {
            label: 'Soll (+)',
            data: SollData.sollHoch.slice(0, arrayLength),
            borderColor: 'rgba(169, 169, 169, 1)',
            borderDash: [5, 5],
            fill: false,
            tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 5,
            borderWidth: 1
        },
        {
            label: 'Soll (-)',
            data: SollData.sollNiedrig.slice(0, arrayLength),
            borderColor: 'rgba(0, 0, 0, 1)',
            borderDash: [5, 5],
            fill: false,
            tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 5,
            borderWidth: 1
        }
    );



    const formattedMilestones = milestones.map(m => ({
        ...m,
        formattedDate: m.date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' })
    }));

    console.log(formattedMilestones);

    return (
        <div style={{ maxWidth: 800, margin: 'auto' }}>
            <ChartWithStats
                chartTitle="Gewichtsentwicklung"
                chartDatasets={chartDatasets}
                chartLabels={labels}
                startDate={[2024, 11, 28]}
                duration={1}
                milestones={formattedMilestones}
                maxValue={3}
            />
        </div>
    );
}

export default ChartFWurfOnly;
